import React from "react";
import PropTypes from "prop-types";
import ImageModal from "./ImageModal";

const ColumnsWithClickableImage = props => (
  <div className="container">
    <h3 className="subtitle is-3 has-text-dark">{props.title}</h3>
    <div className="columns">
      <div className="column is-5">{props.children}</div>
      <div className="column is-offset-1">
        <ImageModal
          src={props.imgSrc}
          alt={props.imgAlt}
          caption={props.imgAlt}
        />
      </div>
    </div>
  </div>
);

ColumnsWithClickableImage.propTypes = {
  caption: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  imgAlt: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default ColumnsWithClickableImage;



// WEBPACK FOOTER //
// ./src/components/ColumnsWithClickableImage.js